import React from "react";

interface Props {
  color?: string;
}

export const MoveOrderIcon = (props: Props) => (
  <svg
    width="56"
    height="56"
    viewBox="0 0 56 56"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      width="48"
      height="48"
      rx="24"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 52 52)"
      fill="#ED6C02"
      fillOpacity="0.4"
    />
    <rect
      width="48"
      height="48"
      rx="24"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 52 52)"
      stroke="#FFEFE1"
      strokeWidth="8"
    />
    <path
      d="M27.9492 23.95L22.9992 19L18.0492 23.95L19.4632 25.364L22.0002 22.828L21.9992 36L23.9992 36L23.9992 22.828L26.5352 25.364L27.9492 23.95ZM37.9492 32.05L36.5352 30.636L33.9992 33.172L33.9992 20L31.9992 20L31.9992 33.172L29.4632 30.636L28.0492 32.05L32.9992 37L37.9492 32.05Z"
      fill="#ED6C02"
    />
  </svg>
);
